"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stars = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var uniqueIdCounter = 0;
var Stars = function Stars() {
  var uniqueId = "uniqueGradient".concat(uniqueIdCounter++);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.9614 1.00946C12.9437 1.05568 12.8788 1.30991 12.8081 1.57569C12.584 2.44816 12.1005 3.40151 11.5049 4.16419C10.8504 4.99043 9.73591 5.85712 8.71579 6.32512C8.24406 6.54468 7.29469 6.84514 7.07652 6.84514C6.85834 6.84514 6.91141 6.94914 7.15317 6.98958C7.9964 7.12825 9.25828 7.70026 10.0956 8.3185C11.0096 8.98873 11.9413 10.1154 12.3835 11.0746C12.5899 11.5252 12.9201 12.5133 12.9201 12.6808C12.9201 12.9004 13.0263 12.8484 13.0675 12.6115C13.1855 11.9528 13.669 10.8203 14.123 10.1501C15.1667 8.61317 16.6527 7.56737 18.4925 7.07047C18.8168 6.9838 19.0409 6.90291 18.9937 6.88558C18.9465 6.86825 18.6871 6.80469 18.4217 6.73536C15.8626 6.08245 13.7987 4.02552 13.1265 1.4428C13.0498 1.15391 12.9791 0.963237 12.9614 1.00946Z",
      fill: "url(#".concat(uniqueId, "_paint0_linear_15_5175)")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M4.05958 8.99654C3.89207 9.51828 3.56302 10.0576 3.13227 10.5148C2.60579 11.0776 2.06137 11.4 1.03235 11.7635C0.948589 11.7928 1.02038 11.8397 1.33148 11.9394C1.9477 12.1328 2.52802 12.4963 3.03056 12.9945C3.54507 13.5104 3.82028 13.9384 4.0536 14.5715C4.14932 14.8353 4.2271 14.9877 4.25103 14.9349C4.26898 14.888 4.34675 14.6711 4.43051 14.4601C4.85528 13.3287 5.86635 12.3673 7.08682 11.9452C7.29023 11.869 7.45775 11.8045 7.45775 11.7987C7.45775 11.7928 7.29023 11.7283 7.08682 11.6521C5.8484 11.2242 4.8134 10.2217 4.4006 9.07275C4.3288 8.86171 4.25103 8.67413 4.2271 8.64481C4.20915 8.62137 4.13138 8.77964 4.05958 8.99654Z",
      fill: "url(#".concat(uniqueId, "_paint1_linear_15_5175)")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9.62448 16.6912C9.43214 17.0588 9.14843 17.3368 8.75894 17.5394L8.45599 17.6996L8.73489 17.8315C9.08111 18.0011 9.44657 18.3592 9.64372 18.722L9.79279 19L9.95147 18.7126C10.1438 18.3545 10.4564 18.0482 10.8218 17.855C10.9757 17.7749 11.1055 17.6996 11.1055 17.6948C11.1055 17.6854 10.9853 17.6195 10.8363 17.5488C10.49 17.3839 10.1102 17.0069 9.93704 16.663C9.86492 16.5169 9.79759 16.3944 9.79279 16.3944C9.78798 16.3944 9.71104 16.5263 9.62448 16.6912Z",
      fill: "url(#".concat(uniqueId, "_paint2_linear_15_5175)")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5.41922 1.44703C5.12843 2.00265 4.69951 2.42293 4.11065 2.72924L3.65265 2.97144L4.0743 3.17089C4.59773 3.42734 5.15024 3.96872 5.4483 4.51722L5.67367 4.9375L5.91357 4.50297C6.20437 3.96159 6.67691 3.49857 7.22942 3.20651C7.46205 3.08541 7.65834 2.97144 7.65834 2.96431C7.65834 2.95007 7.47659 2.85034 7.25123 2.74349C6.7278 2.49417 6.15348 1.92429 5.89176 1.40428C5.78272 1.18346 5.68094 0.99825 5.67367 0.99825C5.6664 0.99825 5.55008 1.19771 5.41922 1.44703Z",
      fill: "url(#".concat(uniqueId, "_paint3_linear_15_5175)")
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "".concat(uniqueId, "_paint0_linear_15_5175"),
        x1: "12.9695",
        y1: "12.8203",
        x2: "12.9695",
        y2: "1.00256",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "".concat(uniqueId, "_paint1_linear_15_5175"),
        x1: "4.22887",
        y1: "14.9453",
        x2: "4.22887",
        y2: "8.64251",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "".concat(uniqueId, "_paint2_linear_15_5175"),
        x1: "9.78076",
        y1: "19",
        x2: "9.78076",
        y2: "16.3944",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "".concat(uniqueId, "_paint3_linear_15_5175"),
        x1: "5.65549",
        y1: "4.9375",
        x2: "5.65549",
        y2: "0.99825",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#5750FA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.494792",
          stopColor: "#514AFA"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#0A00FF"
        })]
      })]
    })]
  });
};
exports.Stars = Stars;